import script from "./domain-blocking-ranking-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./domain-blocking-ranking-chart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__